import { ChangeEvent } from 'react';
import styles from '../../../CreateMemorialQuiltStepThree/styles.module.scss';
import { useRedirectAndScroll } from 'hooks';
import { useTranslates } from 'providers/translates';

type Props = {
  fileInputRef: React.RefObject<HTMLInputElement>;
  changeImages: (event: ChangeEvent<HTMLInputElement>) => Promise<void>;
  isNotAskAccessPermission: boolean;
  openImageChoosing: () => void;
  onSetConfirmChooseImageDialog: () => void;
  isAddImagesOnly: boolean | undefined;
  cancelImage: () => void;
};

const EditorBlockHeader: React.FC<Props> = ({
  fileInputRef,
  changeImages,
  isNotAskAccessPermission,
  openImageChoosing,
  onSetConfirmChooseImageDialog,
  isAddImagesOnly,
  cancelImage
}) => {
  const { translates: t } = useTranslates();
  const addAPhoto = t?.quiltBuilderStepOne?.addAPhoto;
  const { onlyRedirect } = useRedirectAndScroll({});

  return (
    <div className={styles.editorBlock1__header}>
      <div className={styles.editorBlock1__headerLeft}>
        <input
          type="file"
          id="fileInputAddImage"
          multiple
          ref={fileInputRef}
          onChange={changeImages}
          accept="image/png, image/jpeg, image/heic"
          style={{
            display: 'none',
          }}
        />
        <button
          className={`${styles.editorBlock1__button}`}
          onClick={() =>
            isNotAskAccessPermission ? openImageChoosing() : onSetConfirmChooseImageDialog()
          }
        >
          {addAPhoto?.addImagesButtonText ?? 'add images'}
        </button>
        <span className={styles.isDesktop}>{addAPhoto?.addImagesButtonInfo ?? 'Add your images to the album'}</span>
      </div>

      <button
        className={`${styles.editorBlock1__button}`}
        onClick={() => (isAddImagesOnly ? onlyRedirect('/') : cancelImage())}
      >
        {addAPhoto?.exitButtonText ?? 'exit'}
      </button>
    </div>
  );
}

export {EditorBlockHeader };